import { useEffect, useRef, useState } from "react";
import { DashboardPresenter } from "./DashboardPresenter";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ProfileAccountInfo,
} from "api/interfaces/accountInterface.interface";
import { LEVEL_TYPE } from "api/interfaces/commonInterface.interface";
import { useAppSelector } from "redux/hooks";
import { useMenu } from "hook/useMenu";

export function DashboardPage(): JSX.Element {
  const location = useLocation();
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const { returnToStartPage, menuNavigation } = useMenu({});
  const navigate = useNavigate();
  const pathname = location.pathname;
  const initialAccountIdRef = useRef<string>(selectedAccount.accountId);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!pathname.includes("dashboard")) return;
    if (
      !(
        pathname.includes("admin") ||
        pathname.includes("chart") ||
        pathname.includes("map")
      )
    ) {
      returnToStartPage();
    }
  }, [pathname, navigate]);

  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      if (initialAccountIdRef.current === selectedAccount.accountId) {
        if (
          pathname.includes("admin") &&
          selectedAccount.accountLevel !== LEVEL_TYPE.DW
        ) {
          menuNavigation({ to: "/dashboard/map", replace: true });
        } else if (
          (pathname.includes("map") || pathname.includes("chart")) &&
          selectedAccount.accountLevel === LEVEL_TYPE.DW
        ) {
          menuNavigation({ to: "/dashboard/admin", replace: true });
        }
      }
    }, 10000);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [
    selectedAccount.accountId,
    pathname,
    selectedAccount.accountLevel,
    navigate,
  ]);

  if (
    (pathname.includes("admin") &&
      selectedAccount.accountLevel === LEVEL_TYPE.DW) ||
    (pathname.includes("chart") &&
      (selectedAccount.accountLevel === LEVEL_TYPE.CP ||
        selectedAccount.accountLevel === LEVEL_TYPE.EU)) ||
    (pathname.includes("map") &&
      (selectedAccount.accountLevel === LEVEL_TYPE.CP ||
        selectedAccount.accountLevel === LEVEL_TYPE.EU))
  ) {
    return <DashboardPresenter />;
  }
  return <></>;
}
